import { authenticatedApi } from '../utils/api';
import { API_ENDPOINTS } from '../config/api';

export interface StudyDeletionJob {
  jobId: string;
  studyId: string;
  participantId?: string;
  status: 'queued' | 'running' | 'failed' | 'completed';
  step: 'inventory' | 'database' | 'legacy' | 'cloud' | 'exports' | 'records' | 'completed';
  progress?: { rangesDone: number; rangesTotal: number; phase: string; rowsDeleted: number } | null;
  error?: string | null;
}
type Reply = { success: boolean; deletion: StudyDeletionJob | null };
const url = (studyId: string) => API_ENDPOINTS.AUTH.DELETE_STUDY(studyId);
export const studyDeletionService = {
  request: (studyId: string, token: string) => authenticatedApi.delete<Reply>(url(studyId), token),
  get: (studyId: string, token: string) => authenticatedApi.get<Reply>(`${url(studyId)}/deletion`, token),
  retry: (studyId: string, token: string) => authenticatedApi.post<Reply>(`${url(studyId)}/deletion/retry`, {}, token),
};
const participantUrl = (id: string) => API_ENDPOINTS.PARTICIPANTS.DELETE(id);
export const participantDeletionService = {
  request: (id: string, token: string) => authenticatedApi.delete<Reply>(participantUrl(id), token),
  get: (id: string, token: string) => authenticatedApi.get<Reply>(`${participantUrl(id)}/deletion`, token),
  retry: (id: string, token: string) => authenticatedApi.post<Reply>(`${participantUrl(id)}/deletion/retry`, {}, token),
};
